'use strict';

angular.module('amexReconciliationApp')
  .component('meetings360DataPanel', {
    templateUrl: 'scripts/views/components/meetings360-data-panel.html',
    controller: function ($scope, Meetings360ThirdPartyDataRepository, ActiveTransactionModel) {
      var self = this;

      self.$onInit = function () {
        ActiveTransactionModel.onActiveTransactionChanged($scope, fetchThirdPartyData);
      };

      function fetchThirdPartyData() {
        var transaction = ActiveTransactionModel.activeTransaction();
        self.meetings360 = {};
        if (transaction) {
          Meetings360ThirdPartyDataRepository.getMeeting360ThirdPartyData(transaction.id).then(function (data) {
            self.meetings360 = data;
          });
        }
      }
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/meetings360DataPanel.js
// module id = 458
// module chunks = 0